import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import auth from "../../firebase.init";
import Loading from "./Loading";
import { signOut } from "firebase/auth";

const Navbar = () => {
  const [user, loading] = useAuthState(auth);
  const history = useLocation();
  const navigate = useNavigate();

  let currentPath = history.pathname;

  if (loading) {
    return <Loading></Loading>;
  }

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    signOut(auth);
    navigate("/hello-gas/admin/login");
  };

  const menuItem = (
    <>
      {user ? (
        <>
          <li>
            <Link
              to="/hello-gas/admin/dashboard"
              className={
                currentPath === "/hello-gas/admin/dashboard" ? "active" : ""
              }
            >
              Dashboard
            </Link>
          </li>
          <li className="mt-2 md:ml-2 md:mt-0">
            <button
              onClick={handleLogout}
              className="btn btn-secondary text-white"
            >
              Logout
            </button>
          </li>
        </>
      ) : (
        <>
          <li>
            <Link
              to="/home"
              className={currentPath === "/home" ? "active" : ""}
            >
              Home
            </Link>
          </li>
          <li>
            <Link
              to="/store"
              className={currentPath === "/store" ? "active" : ""}
            >
              Store
            </Link>
          </li>
        </>
      )}
    </>
  );

  return (
    <header>
      <nav className="navbar bg-base-100">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex="0" className="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabIndex="0"
              className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
            >
              {menuItem}
            </ul>
          </div>
          <Link to="/" className="normal-case text-xl">
            <img
              src="https://i.ibb.co/J5BWLrd/logo.png"
              alt="logo_img"
              style={{ width: "100px", height: "100px" }}
            />
          </Link>
        </div>
        <div className="navbar-end hidden lg:flex">
          <ul className="menu menu-horizontal p-0">{menuItem}</ul>
        </div>
        {currentPath === "/hello-gas/admin/dashboard" && (
          <div className="navbar-end lg:hidden">
            <label
              tabIndex="1"
              htmlFor="dashboardSidebar"
              className="btn btn-ghost lg:hidden"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Navbar;
